/**
 * In production builds, silence console.log/info/debug/warn so noisy
 * dev-time logs don't ship to end users (perf + security).
 *
 * console.error is preserved — those go through the GlobalErrorHandler
 * and onto our error_logs table for triage.
 *
 * Must run before any feature code logs anything.
 */
export function silenceConsoleInProduction() {
  if (import.meta.env.DEV) return;
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  const noop = () => {};
  // Keep console.error active for crash visibility; mute the rest.
  console.log = noop;
  console.info = noop;
  console.debug = noop;
  console.warn = noop;
}
